import React, { useEffect } from 'react';
import PasswordReset from '../../components/PasswordReset/';
import UIStore from '../../stores/UIStore';

const ChangePassword = () => {
    useEffect(() => {
        UIStore.setSelectedKey(['password']);
        UIStore.setDocumentTitle('Change Password');
    }, []);

    return (
        <section data-testid="page-customer-settings-password" data-ready="true" style={{ maxWidth: '400px' }}>
            <PasswordReset
                formTestId="customer-settings-password-form"
                panelTestId="customer-settings-password-panel"
            />
        </section>
    );
};

export default ChangePassword;
